import { useDebounce } from 'use-debounce'

const useDebounced = <T>(value: T, delayMs: number = 300) => useDebounce(value, delayMs)

export default useDebounced
